import { RootState } from 'client/_redux/reducers';
import {
  getCategoryTourDashboardById,
  updateCategoryTourDashboard,
  deleteCategoryTourDashboard,
} from 'dashboard/_redux/actions/categoryTours';
import { ICategoryTour } from 'client/models/ICategoryTour';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

export const useCategoryTourDetails = () => {
  const { id } = useParams<{ id: string }>();
  const [t] = useTranslation();
  const history = useNavigate();
  const selectedCategoryTour = useSelector(
    (state: RootState) => state.dashboardCategoryTours.selectedCategoryTour,
  );
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    name_en: '',
    description_en: '',
  });

  useEffect(() => {
    if (!id || typeof id !== 'string') return;

    dispatch(getCategoryTourDashboardById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (selectedCategoryTour) {
      setFormData({
        name: selectedCategoryTour.name,
        description: selectedCategoryTour.description,
        name_en: selectedCategoryTour.name_en || '',
        description_en: selectedCategoryTour.description_en || '',
      });
    }
  }, [selectedCategoryTour]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(updateCategoryTourDashboard(id, formData));
  };

  const handleDelete = () => {
    if (window.confirm(t('dashboard.categoryTourPage.confirmDelete') || 'Êtes-vous sûr de vouloir supprimer cette catégorie ?')) {
      dispatch(
        deleteCategoryTourDashboard(id, () => {
          history('/dashboard/categories-tour');
        }),
      );
    }
  };

  return {
    selectedCategoryTour,
    formData,
    handleInputChange,
    handleSubmit,
    handleDelete,
    t,
  };
};
